/*
 * サブシステム名：請求
 * 機能名：請求書発行
 * 表示項目カスタマイズ(光陽テクノサービス)
 */

import D2BILD0010 from '@/views/BIL/D2BILD0010.js'

export default {
  extends: D2BILD0010,
  name: 'SeikyuList',
  data: () => ({
    custoMizeHeaders: [
      { text: '明細', value: 'actions', align: 'center', sortable: false },
      // { text: '請求書', value: 'seikyusho' },
      // { text: '仮発行', value: 'seikyushoKarihakkoFlg', align: 'center' },
      // { text: '銀行１', value: 'bankCheck1', align: 'center' },
      { text: '三井住友', value: 'bankCheck1', class: 'checkbox-col' },
      { text: '千葉銀行', value: 'bankCheck2', class: 'checkbox-col' },
      { text: '京葉銀行', value: 'bankCheck3', class: 'checkbox-col' },
      { text: 'ステータス', value: 'seikyushoStatus', align: 'center' },
      { text: '出力種別', value: 'outputStatus', align: 'center' },
      { text: '請求番号', value: 'seikyuNo' },
      { text: '請求先', value: 'torihikisakiNm' },
      { text: '締日', value: 'shimeDayDisp', align: 'center' },
      { text: '当月請求額', value: 'konkaiSeikyuKingaku', align: 'right' },
      { text: '(運賃)', value: 'kihonUnchiGokei', align: 'right' },
      { text: '(割増)', value: 'warimashiKingakuGokei', align: 'right' },
      { text: '(その他課税)', value: 'kazeiKingakuGokei', align: 'right' },
      { text: '(消費税)', value: 'konkaiTax', align: 'right' },
      { text: '(高速代)', value: 'hiwayPriceGokei', align: 'right' },
      { text: '(その他内税)', value: 'uchizeiKingakuGokei', align: 'right' },
      { text: '(その他非課税)', value: 'hikazeiKingakuGokei', align: 'right' },
      { text: '発行者', value: 'hakkoshaNm' },
      { text: '発行日', value: 'seikyushoHakkoYmd' },
      { text: 'メール送信日', value: 'mailSndrcvDate' },
      { text: '取消者', value: 'torikeshishaNm' },
      { text: '取消日', value: 'torikeshiYmd' },
      { text: '請求日', value: 'seikyuYmd' },
      { text: '入金予定日', value: 'nyukinYoteiYmd' },
      { text: '営業所', value: 'eigyoshoNm' }
      // { text: '固有コード1', value: 'userCustomCd1' },
      // { text: '固有コード2', value: 'userCustomCd2' }
    ]
  })
}
